style =
  width: '16px'
  height: '16px'
  background: 'url("./images/loader.gif") center center no-repeat'
  display: 'inline-block'

module.exports = (props) ->
  <div className="spinner-el--small" style={style} />
